export default __webpack_public_path__ + "static/media/step1.76937db5.png";